module.exports = __webpack_public_path__ + "img/img_sf_parts2.af461aab.svg";